var _jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Mobile/index.js",
  _this = this;
import React, { useContext } from 'react';
import { AccordionItem, Accordion } from '@sm/wds-react';
import LogInCTA from '../../components/LogInCTA';
import SignUpCTA from '../../components/SignUpCTA';
import { MobileScreen } from '../../../..';
import { PlansAndPricingMenu } from './PlansAndPricingMenu';
import { HelpCenterMenu } from './HelpCenterMenu';
import { ProductsMenu } from './ProductsMenu';
import { SolutionsMenu } from './SolutionsMenu';
import { ResourcesMenu } from './ResourcesMenu';
import { MenusWithoutSubMenu } from './components/MenusWithoutSubMenu';
import SMHeaderContext from '../../SMHeaderContext';
import { showBlog } from '../../../../helpers/languageHelpers';
import './mobile-menu-anon.scss';
import { productsMenu, solutionsMenu, resourcesMenu } from '../../config/linkInfo.js';
export var MobileAnon = function MobileAnon() {
  var _useContext = useContext(SMHeaderContext),
    lang = _useContext.lang;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Accordion, {
    noRules: true,
    interactive: true,
    className: "sm-mobile-menu-anon",
    "data-testid": "MobileMenuAnon",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(AccordionItem, {
    title: productsMenu().title,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(ProductsMenu, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(AccordionItem, {
    title: solutionsMenu().title,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(SolutionsMenu, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 11
    }
  })), showBlog(lang) ? /*#__PURE__*/React.createElement(AccordionItem, {
    title: resourcesMenu().title,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(ResourcesMenu, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 13
    }
  })) : null), /*#__PURE__*/React.createElement(MenusWithoutSubMenu, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 7
    }
  }, !showBlog(lang) ? /*#__PURE__*/React.createElement(HelpCenterMenu, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 28
    }
  }) : null, /*#__PURE__*/React.createElement(PlansAndPricingMenu, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement(MobileScreen, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "sm-mobile-menu-anon",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(SignUpCTA, {
    size: "md",
    variant: "solid",
    color: "upgrade",
    stretched: true,
    className: "sm-mobile-menu-anon__cta",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement(LogInCTA, {
    size: "md",
    variant: "solid",
    color: "primary",
    stretched: true,
    className: "sm-mobile-menu-anon__cta",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 65,
      columnNumber: 11
    }
  }))));
};
export default MobileAnon;
//# sourceMappingURL=index.js.map